// Оператор панелінің аудармалары.
//
// Кітапхана қосқан жоқпыз (i18next т.б.) — панельде екі-ақ тіл бар және
// жолдар саны аз, сондықтан қарапайым сөздік `ThemeContext` үлгісімен
// жеткілікті. Кілт атауы — ағылшынша, мағынасы бойынша топталған.

const operator = {
  kk: {
    // Жалпы
    "app.support": "Қолдау",
    "app.operatorPanel": "Оператор панелі",
    "app.theme": "Тема",
    "app.language": "Тіл",
    "app.logout": "Шығу",
    "app.back": "Артқа",
    "app.close": "Жабу",
    "app.cancel": "Болдырмау",
    "app.save": "Сақтау",
    "app.refresh": "Жаңарту",
    "app.loading": "Жүктелуде…",
    "app.error": "Қате",

    // Бөлімдер
    "tab.queue": "Кезек",
    "tab.mine": "Менің чаттарым",
    "tab.closed": "Жабылғандар",
    "tab.stats": "Статистика",

    // Тізім
    "list.emptyQueue": "Кезек бос",
    "list.emptyMine": "Сізге бекітілген чат жоқ",
    "list.emptyClosed": "Жабылған чат жоқ",
    "list.empty": "Чат жоқ",
    "list.user": "Пайдаланушы",
    "list.claim": "Қабылдау",
    "list.claimFailed": "Қабылдау сәтсіз аяқталды",

    // Сүзгі
    "filter.search": "Іздеу: аты / нөмір / email",
    "filter.newChat": "Жаңа чат бастау",
    "filter.unread": "Оқылмағаны",
    "filter.priority": "Маңыздылығы",
    "filter.priorityAll": "Бәрі",
    "filter.priorityLow": "Төмен",
    "filter.priorityNormal": "Қалыпты",
    "filter.priorityHigh": "Жоғары",
    "filter.priorityUrgent": "Шұғыл",

    // Әңгіме
    "chat.messagePlaceholder": "Хабарлама…",
    "chat.file": "Файл",
    "chat.location": "Локация",
    "call.start": "Қоңырау шалу",
    "call.completed": "Қоңырау",
    "call.missed": "Жауапсыз қоңырау",
    "call.declined": "Қабылданбаған қоңырау",
    "chat.sent": "Жіберілді",
    "chat.read": "Оқылды",
    "chat.today": "Бүгін",
    "chat.yesterday": "Кеше",
    "call.ringing": "Шырылдауда…",
    "call.connecting": "Қосылуда…",
    "call.active": "Сөйлесуде",
    "call.mute": "Микрофонды өшіру",
    "call.hangup": "Тұтқаны қою",
    "chat.voiceMessage": "Дауыстық хабарлама",
    "chat.announcement": "Жарнама",
    "chat.link": "Сілтеме",
    "chat.attach": "Файл тіркеу",
    "chat.recordVoice": "Дауыс жазу",
    "chat.stopRecording": "Жазуды тоқтату",
    "chat.uploading": "Жүктелуде…",
    "chat.addTag": "Тег қосу (Enter)",
    "chat.close": "Чатты жабу",
    "chat.reopen": "Қайта ашу",
    "chat.transfer": "Басқа операторға беру",
    "chat.resolutionNote": "Шешім туралы жазба",
    "chat.editMessage": "Хабарламаны өңдеу",
    "chat.internalNote": "Ішкі жазба",
    "chat.cannedResponses": "Дайын жауаптар",
    "chat.selectChat": "Сол жақтан чат таңдаңыз",
    "chat.profile": "Профиль",
    "chat.reply": "Жауап беру",
    "chat.delete": "Өшіру",

    // Профиль
    "profile.title": "Профиль",
    "profile.oldChats": "Ескі чаттар",
    "profile.phone": "Телефон",
    "profile.email": "Email",
    "profile.registered": "Тіркелген",
    "profile.balance": "Баланс",
    "profile.tariff": "Тариф",

    // Іздеу терезесі
    "search.title": "Пайдаланушыны іздеу",
    "search.placeholder": "Аты / нөмір / email / id…",
    "search.startChat": "Чат бастау",
    "search.notFound": "Ештеңе табылмады",

    // Статистика
    "profile.userProfile": "Пайдаланушы профилі",
    "profile.type": "Түрі",
    "profile.dealerRole": "Сатушы рөлі",
    "profile.rating": "Рейтинг",
    "profile.active": "Аккаунт",
    "profile.accountActive": "белсенді",
    "profile.accountDisabled": "өшірілген",
    "profile.online": "Желіде",
    "profile.onlineNow": "қазір онлайн",
    "profile.lastOnline": "соңғы рет",
    "profile.lastActive": "Соңғы белсенділік",
    "profile.verified": "Расталған",
    "profile.kycStatus": "Күйі",
    "profile.docType": "Құжат түрі",
    "profile.document": "Құжат",
    "profile.announcements": "Жарнамалар",
    "stats.myStats": "Менің статистикам",
    "search.searching": "Ізделуде…",
    "stats.title": "Статистика",
    "stats.closed24h": "24 сағатта жабылған",
    "stats.closed7d": "7 күнде жабылған",
    "stats.open": "Ашық чаттар",
    "stats.avgResponse": "Орташа жауап уақыты",
  },

  ru: {
    "app.support": "Поддержка",
    "app.operatorPanel": "Панель оператора",
    "app.theme": "Тема",
    "app.language": "Язык",
    "app.logout": "Выйти",
    "app.back": "Назад",
    "app.close": "Закрыть",
    "app.cancel": "Отмена",
    "app.save": "Сохранить",
    "app.refresh": "Обновить",
    "app.loading": "Загрузка…",
    "app.error": "Ошибка",

    "tab.queue": "Очередь",
    "tab.mine": "Мои чаты",
    "tab.closed": "Закрытые",
    "tab.stats": "Статистика",

    "list.emptyQueue": "Очередь пуста",
    "list.emptyMine": "Нет назначенных вам чатов",
    "list.emptyClosed": "Нет закрытых чатов",
    "list.empty": "Чатов нет",
    "list.user": "Пользователь",
    "list.claim": "Взять",
    "list.claimFailed": "Не удалось взять чат",

    "filter.search": "Поиск: имя / номер / email",
    "filter.newChat": "Начать новый чат",
    "filter.unread": "Непрочитанные",
    "filter.priority": "Приоритет",
    "filter.priorityAll": "Все",
    "filter.priorityLow": "Низкий",
    "filter.priorityNormal": "Обычный",
    "filter.priorityHigh": "Высокий",
    "filter.priorityUrgent": "Срочный",

    "chat.messagePlaceholder": "Сообщение…",
    "chat.file": "Файл",
    "chat.location": "Локация",
    "call.start": "Позвонить",
    "call.completed": "Звонок",
    "call.missed": "Пропущенный звонок",
    "call.declined": "Отклонённый звонок",
    "chat.sent": "Отправлено",
    "chat.read": "Прочитано",
    "chat.today": "Сегодня",
    "chat.yesterday": "Вчера",
    "call.ringing": "Вызов…",
    "call.connecting": "Соединение…",
    "call.active": "Разговор",
    "call.mute": "Выключить микрофон",
    "call.hangup": "Завершить",
    "chat.voiceMessage": "Голосовое сообщение",
    "chat.announcement": "Объявление",
    "chat.link": "Ссылка",
    "chat.attach": "Прикрепить файл",
    "chat.recordVoice": "Записать голосовое",
    "chat.stopRecording": "Остановить запись",
    "chat.uploading": "Загрузка…",
    "chat.addTag": "Добавить тег (Enter)",
    "chat.close": "Закрыть чат",
    "chat.reopen": "Открыть заново",
    "chat.transfer": "Передать оператору",
    "chat.resolutionNote": "Заметка о решении",
    "chat.editMessage": "Редактировать сообщение",
    "chat.internalNote": "Внутренняя заметка",
    "chat.cannedResponses": "Готовые ответы",
    "chat.selectChat": "Выберите чат слева",
    "chat.profile": "Профиль",

    "profile.title": "Профиль",
    "profile.oldChats": "Прошлые чаты",
    "profile.phone": "Телефон",
    "profile.email": "Email",
    "profile.registered": "Зарегистрирован",
    "profile.balance": "Баланс",
    "profile.tariff": "Тариф",

    "search.title": "Поиск пользователя",
    "search.placeholder": "Имя / номер / email / id…",
    "search.startChat": "Начать чат",
    "search.notFound": "Ничего не найдено",

    "profile.userProfile": "Профиль пользователя",
    "profile.type": "Тип",
    "profile.dealerRole": "Роль продавца",
    "profile.rating": "Рейтинг",
    "profile.active": "Аккаунт",
    "profile.accountActive": "активен",
    "profile.accountDisabled": "отключён",
    "profile.online": "В сети",
    "profile.onlineNow": "сейчас онлайн",
    "profile.lastOnline": "был(а)",
    "profile.lastActive": "Последняя активность",
    "profile.verified": "Подтверждён",
    "profile.kycStatus": "Статус",
    "profile.docType": "Тип документа",
    "profile.document": "Документ",
    "profile.announcements": "Объявления",
    "stats.myStats": "Моя статистика",
    "search.searching": "Поиск…",
    "stats.title": "Статистика",
    "stats.closed24h": "Закрыто за 24 часа",
    "stats.closed7d": "Закрыто за 7 дней",
    "stats.open": "Открытые чаты",
    "stats.avgResponse": "Среднее время ответа",
  },
};

export default operator;
